import styled from 'styled-components/macro';
import { FlexJustifyCenter } from '../../../shared-styles/flex';

export const AlertContainer = styled.div`
  position: absolute;
  z-index: 2000;
  top: 30px;
  left: 0;
  right: 0;
  ${FlexJustifyCenter}
`;

export const NavigationContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
`;
